var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomationDarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.057,
    height: 19.936,
    viewBox: "0 0 20.057 19.936",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160664",
    "data-name": "Group 160664",
    transform: "translate(-367.537 -352.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160572",
    "data-name": "Group 160572",
    transform: "translate(368.579 353.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_993",
    d: "M20.126,13.06a8.34,8.34,0,0,1-6.546,7.37",
    transform: "translate(-3.19 -3.682)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160551",
    "data-name": "Group 160551"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_144",
    "data-name": "Ellipse 144",
    cx: 0.501,
    cy: 0.536,
    rx: 0.501,
    ry: 0.536,
    transform: "translate(13.167 0.8)",
    fill: "#165cf3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_991",
    d: "M2.98,10.154A8.362,8.362,0,0,1,9.175,3.02",
    transform: "translate(-1.899 -2.954)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_992",
    d: "M9.183,20.354a8.377,8.377,0,0,1-6.213-7.3",
    transform: "translate(-1.898 -3.681)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994",
    d: "M18.82,5.89a8.772,8.772,0,0,1,1.924,4.433",
    transform: "translate(-3.826 -3.151)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_994-2",
    d: "M13.58,2.95a4.811,4.811,0,0,1,1.582.536",
    transform: "translate(-3.188 -2.95)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_996",
    d: "M19.4,9.733l1.573.969L21.9,8.98",
    transform: "translate(-3.896 -3.352)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_997",
    d: "M14.439,19.28,13.27,20.767l1.415,1.28",
    transform: "translate(-3.15 -4.047)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_998",
    d: "M4.307,14.038,2.84,12.89l-1.09,1.6",
    transform: "translate(-1.75 -3.612)",
    fill: "none",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "cog-6-tooth",
    transform: "translate(4.176 3.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    d: "M10.563,7.428a.628.628,0,0,1,.63-.508h1.476a.628.628,0,0,1,.63.508l.118.7a.689.689,0,0,0,.364.471c.039.019.089.047.128.066a.731.731,0,0,0,.61.066l.689-.245a.647.647,0,0,1,.777.264l.738,1.224a.58.58,0,0,1-.148.772L16,11.193a.64.64,0,0,0-.246.536v.141a.667.667,0,0,0,.246.536l.571.452a.591.591,0,0,1,.148.772l-.738,1.224a.658.658,0,0,1-.777.264l-.689-.245a.727.727,0,0,0-.61.066.538.538,0,0,1-.128.066.689.689,0,0,0-.364.471l-.118.7a.628.628,0,0,1-.63.508H11.193a.628.628,0,0,1-.63-.508l-.118-.7a.689.689,0,0,0-.364-.471c-.039-.019-.089-.047-.128-.066a.731.731,0,0,0-.61-.066l-.689.245a.647.647,0,0,1-.777-.264l-.738-1.224a.591.591,0,0,1,.148-.772l.571-.452a.64.64,0,0,0,.246-.536V11.73a.667.667,0,0,0-.246-.536l-.571-.452a.591.591,0,0,1-.148-.772l.738-1.224a.658.658,0,0,1,.777-.264l.689.245a.727.727,0,0,0,.61-.066.538.538,0,0,1,.128-.066.689.689,0,0,0,.364-.471l.118-.687Z",
    transform: "translate(-7.054 -6.92)",
    fill: "#f49b31",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    d: "M13.32,12A1.524,1.524,0,1,1,11.8,10.37,1.572,1.572,0,0,1,13.32,12Z",
    transform: "translate(-6.923 -7.123)",
    fill: "#fff",
    stroke: "#165cf3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomationDarkIcon);
export default __webpack_public_path__ + "static/media/automation-dark-icon.4d5700578be78926fc12875e7d1e1fb8.svg";
export { ForwardRef as ReactComponent };